import { PaintBrushIcon } from '@heroicons/react/24/outline';
import { Button } from '@mui/material';
import Modal from '../NewModal';
import useRemixInfoModalStore from './store';

const RemixInfoModal = () => {
  const { isOpen, closeModal } = useRemixInfoModalStore();

  const handleConfirm = () => {
    closeModal();
    // Add any additional logic here if needed
  };

  return (
    <>
      {isOpen && (
        <Modal
          open={isOpen}
          onClose={closeModal}
          title="Remix Your Creation"
          maxWidth="sm"
        >
          <div className="flex flex-col items-center gap-6">
            {/* Icon */}
            <div className="flex items-center justify-center w-16 h-16 bg-lavender rounded-full">
              <PaintBrushIcon className="w-8 h-8 text-violet-blue" />
            </div>

            {/* Content */}
            <div className="text-center">
              <p className="text-raisin-black dark:text-crystal-bell text-base leading-6 font-medium">
                Want to remix your creation? Just locate it below in the chat or
                in your gallery, and press the paintbrush icon.
              </p>
            </div>

            {/* Buttons */}
            <div className="flex gap-3 w-full">
              <Button
                variant="contained"
                onClick={handleConfirm}
                className="flex-1 py-3 px-6 text-base font-semibold bg-nue-blue hover:bg-nue-blue/70 text-white"
                sx={{
                  borderRadius: '12px',
                  textTransform: 'none',
                }}
              >
                Understood
              </Button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default RemixInfoModal;
